export const PICKUP_ALCOHOL_COUPON_CODE = 'COLLECT';
